import { ADD_SELECTED_STATE } from "../actionTypes";

const initialState = {
  selectedState: {
    lat: 16.871311,
    lng: 96.199379,
  },
};

export function locationReducer(state = initialState, action) {
  switch (action.type) {
    case ADD_SELECTED_STATE:
      return {
        ...state,
        selectedState: {
          ...state.selectedState,
          lat: action.state.lat,
          lng: action.state.lng,
        },
      };
    default:
      return state;
  }
}
